export default __webpack_public_path__ + "static/media/goeppingen_dark.3e5d1150.png";